import React from "react";
import { PageTitle, SettingsPanel } from "@/components/SettingsPanel";
import { CustomerProfileCards } from "@/components/ProfileCards";
import { AdminWhatsAppButton } from "@/components/PlatformContact";
import { PushToggle } from "@/components/PushToggle";
import { AccountSecurity } from "@/components/AccountSecurity";
import { FavEventsToggle } from "@/components/FavEventsToggle";
import { DeveloperCard } from "@/components/DeveloperCard";
import { AboutLink } from "@/pages/About";
import { DevicesCard } from "@/components/DevicesCard";
import { usePrefs } from "@/contexts/PrefsContext";

export default function CustomerProfile() {
  const { t } = usePrefs();
  return (
    <div data-testid="customer-profile-page">
      <PageTitle title={t("profile.title")} />
      <SettingsPanel>
        <CustomerProfileCards />
        <AccountSecurity />
        <DevicesCard />
        <PushToggle />
        <FavEventsToggle />
        <AdminWhatsAppButton />
        <DeveloperCard />
        <AboutLink className="px-2" />
      </SettingsPanel>
    </div>
  );
}
